// libs
import { useEffect, useRef, useState } from 'react';
import { useParams, useLocation } from 'react-router-dom';
// constants
import Routes from '@/constants/Routes';
var BreadcrumbPathEnum;
(function (BreadcrumbPathEnum) {
    BreadcrumbPathEnum["DASHBOARD"] = "dashboard";
    BreadcrumbPathEnum["CAMPAIGN_LIST"] = "campaign-list";
    BreadcrumbPathEnum["CAMPAIGN_DETAILS"] = "campaign-details";
    BreadcrumbPathEnum["CAMPAIGN_EDIT"] = "campaign-edit";
    BreadcrumbPathEnum["CAMPAIGN_CREATE"] = "campaign-create";
    BreadcrumbPathEnum["ACCOUNT_SELECT"] = "account-select";
})(BreadcrumbPathEnum || (BreadcrumbPathEnum = {}));
const BreadCrumbsConfig = {
    [BreadcrumbPathEnum.CAMPAIGN_EDIT]: {
        id: BreadcrumbPathEnum.CAMPAIGN_EDIT,
        title: 'Edit Campaign',
        regexPath: /^\/campaign\/[0-9a-zA-Z-]+\/edit\/?$/,
        path: (id) => `/campaign/${id}/edit`,
        visible: true,
        crumbs: [
            BreadcrumbPathEnum.DASHBOARD,
            BreadcrumbPathEnum.CAMPAIGN_DETAILS,
            BreadcrumbPathEnum.CAMPAIGN_EDIT,
        ],
    },
    [BreadcrumbPathEnum.CAMPAIGN_LIST]: {
        id: BreadcrumbPathEnum.CAMPAIGN_LIST,
        title: 'All Campaigns',
        regexPath: /^\/campaign\/list\/?$/,
        path: () => `/campaign/list`,
        visible: true,
        crumbs: [
            BreadcrumbPathEnum.DASHBOARD,
            BreadcrumbPathEnum.CAMPAIGN_LIST,
        ],
    },
    [BreadcrumbPathEnum.CAMPAIGN_DETAILS]: {
        id: BreadcrumbPathEnum.CAMPAIGN_DETAILS,
        title: 'Campaign Details',
        regexPath: /^\/campaign\/(?!create($|\/))[0-9a-zA-Z-]+\/?$/,
        path: (id) => `/campaign/${id}`,
        visible: true,
        crumbs: [
            BreadcrumbPathEnum.DASHBOARD,
            BreadcrumbPathEnum.CAMPAIGN_DETAILS,
        ],
    },
    [BreadcrumbPathEnum.CAMPAIGN_CREATE]: {
        id: BreadcrumbPathEnum.CAMPAIGN_CREATE,
        title: 'Create Campaign',
        regexPath: /^\/campaign\/create\/?$/,
        path: () => `/campaign/create`,
        visible: true,
        crumbs: [
            BreadcrumbPathEnum.DASHBOARD,
            BreadcrumbPathEnum.CAMPAIGN_CREATE,
        ],
    },
    [BreadcrumbPathEnum.DASHBOARD]: {
        id: BreadcrumbPathEnum.DASHBOARD,
        title: 'Dashboard',
        regexPath: /^\/?$/,
        path: () => `/`,
        visible: false,
        crumbs: [BreadcrumbPathEnum.DASHBOARD],
    },
    [BreadcrumbPathEnum.ACCOUNT_SELECT]: {
        id: BreadcrumbPathEnum.ACCOUNT_SELECT,
        title: 'Account Select',
        regexPath: /^\/account-select?$/,
        path: () => Routes.ACCOUNT_SELECT,
        visible: false,
        crumbs: [
            BreadcrumbPathEnum.DASHBOARD,
            BreadcrumbPathEnum.ACCOUNT_SELECT,
        ],
    },
};
function getCrumbs(params, config) {
    if (!config)
        return [];
    return config.crumbs.map((crumbId) => {
        const crumbConfig = BreadCrumbsConfig[crumbId];
        return {
            title: crumbConfig.title,
            path: crumbConfig.path(params.id),
        };
    });
}
function useBreadcrumb() {
    const params = useParams();
    const location = useLocation();
    const currentConfig = useRef();
    const [crumbs, setCrumbs] = useState(() => {
        return getCrumbs(params, currentConfig.current);
    });
    useEffect(() => {
        var _a;
        const [_, config] = (_a = Object.entries(BreadCrumbsConfig).find(([_, config]) => config.regexPath.test(location.pathname))) !== null && _a !== void 0 ? _a : [];
        currentConfig.current = config;
        if (!config || !config.visible) {
            setCrumbs([]);
        }
        else {
            const crumbs = getCrumbs(params, config);
            setCrumbs(crumbs);
        }
    }, [location.pathname]);
    return {
        crumbs,
        currentPathConfig: currentConfig,
    };
}
export default useBreadcrumb;
